
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Checks if an item exists in an array
 */
@Pipe({
    name: 'includes',
    standalone: false
})
export class IncludesPipe implements PipeTransform {

    /**
     * Checks if an item exists in an array
     * @param array An array of items of type T
     * @param value An item of type T
     */
    transform<T = any>(
        array: T[],
        value: T
    ): boolean {
        return Array.isArray(array) && array.includes(value);
    }
}
